import React from 'react';
import { Play } from 'lucide-react';

const getYouTubeId = (url) => {
  if (!url) return null;
  const match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/);
  return match && match[2].length === 11 ? match[2] : null;
};

const GalleryItem = ({ item, onClick }) => (
  <div onClick={onClick}
    className="group relative aspect-square cursor-pointer overflow-hidden rounded-lg bg-gray-900 hover:scale-105 transition-all duration-300">
    {item.type === 'image' ? (
      <img src={item.url} alt={item.title || 'Gallery item'}
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
    ) : item.youtube_url ? (
      <div className="relative w-full h-full">
        <img src={`https://img.youtube.com/vi/${getYouTubeId(item.youtube_url)}/maxresdefault.jpg`}
          alt={item.title || 'Video thumbnail'}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          onError={(e) => {
            try {
              if (e.target?.src?.includes('maxresdefault')) {
                e.target.src = `https://img.youtube.com/vi/${getYouTubeId(item.youtube_url)}/hqdefault.jpg`;
              } else if (e.target?.style) { e.target.style.display = 'none'; }
            } catch (err) { console.warn('YouTube thumbnail fallback:', err); }
          }} />
        <div className="absolute inset-0 flex items-center justify-center bg-black/60">
          <Play size={48} className="text-white opacity-80 group-hover:scale-110 transition-transform duration-300" />
        </div>
      </div>
    ) : (
      <div className="relative w-full h-full bg-gray-800">
        <video src={item.url} className="w-full h-full object-cover" preload="metadata" muted playsInline
          onError={(e) => { try { if (e.target?.style) e.target.style.display = 'none'; } catch (err) { console.warn('Video load fallback:', err); } }} />
        <div className="absolute inset-0 flex items-center justify-center bg-black/40">
          <Play size={48} className="text-white opacity-80 group-hover:scale-110 transition-transform duration-300" />
        </div>
      </div>
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
      <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
        {item.title && <h3 className="text-white font-semibold mb-1 group-hover:text-orange-400 transition-colors duration-300">{item.title}</h3>}
        {item.caption && <p className="text-gray-300 text-sm line-clamp-2 group-hover:text-gray-100 transition-colors duration-300">{item.caption}</p>}
      </div>
    </div>
  </div>
);

export const GalleryGrid = ({ items, onItemClick }) => {
  if (items.length === 0) {
    return (
      <div className="text-center text-gray-400 py-20">
        <p className="text-xl">No items in this gallery yet.</p>
        <p className="text-sm mt-2">Check back soon for updates!</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {items.map((item, index) => (
        <GalleryItem key={item.id} item={item} onClick={() => onItemClick(index)} />
      ))}
    </div>
  );
};
